<!-- svelte-ignore a11y-label-has-associated-control -->
<!-- svelte-ignore a11y-missing-attribute -->
<nav class="navbar x-is-spaced" role="navigation" aria-label="main navigation">
  <div class="navbar-brand">
    <a class="navbar-item" href="/">
      <img src="/assets/img/logo_h.png" height="38" />
    </a>

    <a
      on:click={() => (isMobileMenuActive = !isMobileMenuActive)}
      role="button"
      class="navbar-burger"
      class:is-active={isMobileMenuActive}
      aria-label="menu"
      aria-expanded="false"
      data-target="navbarBasicExample">
      <span aria-hidden="true" />
      <span aria-hidden="true" />
      <span aria-hidden="true" />
    </a>
  </div>

  <div
    id="navbarBasicExample"
    class="navbar-menu"
    class:is-active={isMobileMenuActive}>
    <div class="navbar-start">
      <a
        class="navbar-item is-tab"
        class:is-active={$isActive('./index')}
        href={$url('./index')}>
        Home
      </a>

      <a
        class="navbar-item is-tab"
        class:is-active={$isActive('./offers')}
        href={$url('./offers')}>
        {#if $appState.user?.isAdmin}
          Your offers
        {:else}
          Offers
        {/if}
      </a>

      <a
        class="navbar-item is-tab"
        class:is-active={$isActive('./needs')}
        href={$url('./needs')}>
        Local charity needs
      </a>

      <a
        class="navbar-item is-tab"
        class:is-active={$isActive('./profile')}
        href={$url('./profile/company')}>
        Profile
      </a>

      {#if hasActiveSubscription($appState.company)}
        <div class="navbar-item">
          <a href={$url('./profile/subscription')}>
            <span class="tag is-danger is-small"
              >Premium Access {#if subscriptionDaysRemaining($appState.company) < 7}{subscriptionDaysRemaining(
                  $appState.company
                )} days remaining{/if}</span>
          </a>
        </div>
      {:else if $appState.company?.subscriptions?.current?.expiryDate && subscriptionDaysRemaining($appState.company) > -90}
        <div class="navbar-item">
          <a href={$url('./profile/subscription')}>
            <span class="tag is-small">Premium Access expired</span>
          </a>
        </div>
      {/if}
    </div>

    <div class="navbar-end">
      <div class="navbar-item">
        <div class="buttons">
          <a class="button is-primary" on:click={createOffer}>
            <strong>Create offer</strong>
          </a>
        </div>
      </div>
      <div class="navbar-item">
        <div class="buttons">
          <div class="dropdown is-hoverable is-right">
            <div class="dropdown-trigger">
              <a>
                {#if $appState.user}
                  <img
                    src="https://ui-avatars.com/api/?name={$appState.user
                      .firstName}+{$appState.user.lastName}&rounded=true"
                    height="38" />
                {/if}
              </a>
            </div>
            <div class="dropdown-menu" id="dropdown-menu" role="menu">
              <div class="dropdown-content has-text-right">
                <a href="/business/profile/contact" class="dropdown-item">
                  Profile
                </a>
                <a class="dropdown-item" on:click={logoff}> Logoff </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</nav>

<script>
  import { isActive, url, goto, beforeUrlChange } from '@sveltech/routify';
  import { appState } from '../../../lib/appState';
  import { uiState } from '../../../lib/uiState';
  import Premium from '../offers/_components/Premium.svelte';
  import {
    hasActiveSubscription,
    subscriptionDaysRemaining
  } from '../../../lib/subscriptionHelper';
  import { createEventDispatcher } from "svelte";
  const dispatch = createEventDispatcher();

  let isMobileMenuActive = false;

  // close menu on navigation
  $beforeUrlChange(() => {
    isMobileMenuActive = false;
    return true;
  });

  async function logoff() {
    dispatch("logoff");
  }

  function createOffer() {
    if (hasActiveSubscription($appState.company)) {
      $goto('/business/offers/create');
    } else {
      $uiState.activeModal = {
        component: Premium,
        props: {}
      };
    }
  }
</script>

<style>
  .navbar {
    padding: 0rem 1rem;
    border-bottom: 1px solid #eee;
  }

  .navbar-item img {
    max-height: 2.2rem !important;
  }

  .navbar-item.is-tab {
    font-weight: 500;
  }
</style>
